import React, { createContext, useCallback, useReducer } from "react";
import ViewFile from "../components/ViewFile/ViewFile";
import { groupBy } from "../utils";
import { AttachmentsReducer } from "./attachmentsReducer";
import { TYPES } from "./attachmentsTypes";

const Attachments = createContext();

export const initialState = {
  fileToView: null,
  blobLocalURL: null,
};

const AttachmentsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AttachmentsReducer, initialState);

  const compiledChapter = (data, type, condition) => {
    const filtered = data.filter(
      (e) => getAttachmentType(e)?.name === condition
    );

    if (type === "varieties") {
      return groupBy(filtered, (u) => u.version);
    }

    const hasBlockNumber = filtered.some((u) => u.blockNumber != null);
    return groupBy(
      filtered,
      hasBlockNumber
        ? (u) => u.blockNumber && u.chapterNumber
        : (u) => u.chapterNumber
    );
  };

  const getAttachmentType = (attachment) =>
    attachment.attachmentType ?? attachment.type;

  const compileAll = (data, condition, groupSupplementaryMaterial = false) =>
    groupBy(
      data.filter((attachment) => {
        const typeName = getAttachmentType(attachment)?.name;
        return (
          (groupSupplementaryMaterial ||
            typeName !== "Material Complementar") &&
          typeName !== condition &&
          typeName !== "Adendo"
        );
      }),
      (attachment) => getAttachmentType(attachment)?.id
    );

  const compileMaterial = (data) =>
    data.reduce((acc, attachment) => {
      if (getAttachmentType(attachment)?.name === "Material Complementar") {
        acc[attachment.id] = [attachment];
      }
      return acc;
    }, {});

  const compileAddendum = (data) =>
    data.reduce((acc, attachment) => {
      if (getAttachmentType(attachment)?.name === "Adendo") {
        acc[attachment.id] = [attachment];
      }
      return acc;
    }, {});

  const setFileToView = useCallback(
    (payload) => dispatch({ type: TYPES.SET_FILE_TO_VIEW, payload }),
    []
  );

  const setBlobLocalURL = useCallback((payload) => {
    dispatch({ type: TYPES.SET_BLOB_LOCAL_URL, payload });
  }, []);

  const setClear = useCallback(
    (payload) => dispatch({ type: TYPES.SET_CLEAR }),
    []
  );

  return (
    <Attachments.Provider
      value={{
        ...state,
        compileAll,
        compiledChapter,
        compileMaterial,
        compileAddendum,
        setFileToView,
        setBlobLocalURL,
        setClear,
      }}
    >
      {state?.fileToView && <ViewFile file={state?.fileToView} />}
      {children}
    </Attachments.Provider>
  );
};

export { Attachments as default, AttachmentsProvider };
